import { render, staticRenderFns } from "./CreateHotKeywords.vue?vue&type=template&id=8f8edd2c&scoped=true"
import script from "./CreateHotKeywords.vue?vue&type=script&lang=js"
export * from "./CreateHotKeywords.vue?vue&type=script&lang=js"
import style0 from "./CreateHotKeywords.vue?vue&type=style&index=0&id=8f8edd2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8edd2c",
  null
  
)

export default component.exports